import React from 'react';

import { OrganizationAppShell, OrganizationSettings, Settings } from '~/components/layouts';
import { BankAccount } from '~/components/pages/Settings_Organization_BankAccount';
import { FirebaseProvider } from '~/components/partials';

const SettingsOrganizationBankAccountPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Settings>
          <OrganizationSettings>
            <BankAccount />
          </OrganizationSettings>
        </Settings>
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default SettingsOrganizationBankAccountPage;
